import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import "./HomePageTheBilingualProject.css";

const HomePageTheBilingualProject = () => {
  const navigate = useNavigate(); // Hook for navigation

  // Function to handle button click and redirect to /BilingualProject
  const handleBilingualProjectClick = () => {
    navigate("/BilingualProject"); // Replace "/BilingualProject" with your actual route
  };

  return (
    <section className="bilingual-section py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-3">The Bilingual Project</h2>
            <p className="lead">
              Immersive English learning for children aged 3-6 through music,
              storytelling, and interactive play.
            </p>
          </Col>
        </Row>
        <Row className="g-4">
          {/* Music & Rhythm Card */}
          <Col lg={4} className="d-flex justify-content-center">
            <div className="flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <i className="mdi mdi-music-note fs-36 text-primary"></i>
                  <h5 className="fw-bold">Music & Rhythm</h5>
                </div>
                <div className="flip-card-back flip-card-backMusic">
                  <i className="mdi mdi-music-note fs-36 text-white"></i>
                  <h5 className="fw-bold">Music & Rhythm</h5>
                  <p>
                    Children learn English through songs and rhythmic activities.
                  </p>
                </div>
              </div>
            </div>
          </Col>

          {/* Storytelling Card */}
          <Col lg={4} className="d-flex justify-content-center">
            <div className="flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <i className="mdi mdi-book-open-variant fs-36 text-success"></i>
                  <h5 className="fw-bold">Storytelling</h5>
                </div>
                <div className="flip-card-back flip-card-backStoryTelling">
                  <i className="mdi mdi-book-open-variant fs-36 text-white"></i>
                  <h5 className="fw-bold">Storytelling</h5>
                  <p>
                    Engaging stories that make learning English fun and
                    memorable.
                  </p>
                </div>
              </div>
            </div>
          </Col>

          {/* Interactive Play Card */}
          <Col lg={4} className="d-flex justify-content-center">
            <div className="flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <i className="mdi mdi-puzzle fs-36 text-danger"></i>
                  <h5 className="fw-bold">Interactive Play</h5>
                </div>
                <div className="flip-card-back flip-card-backInteractivePlay">
                  <i className="mdi mdi-puzzle fs-36 text-white"></i>
                  <h5 className="fw-bold">Interactive Play</h5>
                  <p>
                    Hands-on activities that encourage creativity and
                    communication.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Button to redirect to /BilingualProject */}
        <Row className="justify-content-center mt-5">
          <Col lg={6} className="text-center">
            <button
              className="bilingual-button"
              onClick={handleBilingualProjectClick}
            >
              Explore the Bilingual Project
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomePageTheBilingualProject;